import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

export const useTenantTourMobile = () => {
  const { user } = useSelector((state) => state.landlordslice);
  const [shouldShowTour, setShouldShowTour] = useState(false);
  const [shouldShowWelcome, setShouldShowWelcome] = useState(false);
  const [deviceType, setDeviceType] = useState("mobile"); // "mobile" or "tablet"
  const [resumeAtStep, setResumeAtStep] = useState(null);

  // Detect device type based on screen size
  useEffect(() => {
    const detectDeviceType = () => {
      const width = window.innerWidth;
      if (width >= 768 && width < 1024) {
        setDeviceType("tablet");
      } else if (width < 768) {
        setDeviceType("mobile");
      }
    };

    detectDeviceType();
    window.addEventListener("resize", detectDeviceType);

    return () => {
      window.removeEventListener("resize", detectDeviceType);
    };
  }, []);

  useEffect(() => {
    if (user?.data?.user?.user_id) {
      // Check if tour has been completed for this user on mobile/tablet
      const tourCompleted = localStorage.getItem(
        `tenant_tour_completed_${deviceType}_${user.data.user.user_id}`
      );

      // Check if this is the user's first visit to the mobile dashboard
      const firstVisit = localStorage.getItem(
        `tenant_first_visit_${deviceType}_${user.data.user.user_id}`
      );

      // Show welcome banner if it hasn't been completed and this is a first visit
      if (!tourCompleted && !firstVisit) {
        setShouldShowWelcome(true);
        // Mark that user has visited the mobile dashboard
        localStorage.setItem(
          `tenant_first_visit_${deviceType}_${user.data.user.user_id}`,
          "true"
        );
      }
    }
  }, [user, deviceType]);

  const startTour = () => {
    setShouldShowWelcome(false);
    setShouldShowTour(true);
    setResumeAtStep(null);
  };

  const endTour = () => {
    setShouldShowTour(false);
    // Mark tour as completed when ended
    if (user?.data?.user?.user_id) {
      localStorage.setItem(
        `tenant_tour_completed_${deviceType}_${user.data.user.user_id}`,
        "true"
      );
    }
    setResumeAtStep(null);
  };

  const dismissWelcome = () => {
    setShouldShowWelcome(false);
    if (user?.data?.user?.user_id) {
      localStorage.setItem(
        `tenant_tour_completed_${deviceType}_${user.data.user.user_id}`,
        "true"
      );
    }
  };

  const resetTour = () => {
    if (user?.data?.user?.user_id) {
      localStorage.removeItem(
        `tenant_tour_completed_${deviceType}_${user.data.user.user_id}`
      );
      localStorage.removeItem(
        `tenant_first_visit_${deviceType}_${user.data.user.user_id}`
      );
      setShouldShowTour(true);
      setShouldShowWelcome(false);
      setResumeAtStep(null);
    }
  };

  const resumeTourAtStep = (stepIndex) => {
    setShouldShowTour(true);
    setShouldShowWelcome(false);
    setResumeAtStep(stepIndex);
  };

  return {
    shouldShowTour,
    shouldShowWelcome,
    deviceType,
    resumeAtStep,
    startTour,
    endTour,
    dismissWelcome,
    resetTour,
    resumeTourAtStep,
  };
};

export default useTenantTourMobile;
